
import { Observable } from './druid/./druid/Observable';
import { throttleTime } from './druid/./druid/operator/throttleTime';

Observable.prototype.throttleTime = throttleTime;

declare module './druid/./druid/Observable' {
  interface Observable<T> {
    throttleTime: typeof throttleTime;
  }
}